import React from 'react';
import createIcon from './createIcon';

const LocalMed = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>LocalMed</title>
    <path
      d="M199.53,53.77A21.53,21.53,0,0,1,221,32.26H291a21.53,21.53,0,0,1,21.5,21.5V232.53h-27l43.11,43.09,43.1-43.09h-27V53.77A53.82,53.82,0,0,0,291,0H221a53.82,53.82,0,0,0-53.76,53.76V128h32.26Z"
      transform="translate(0 -0.01)"
    />
    <path
      d="M312.47,458.23a21.53,21.53,0,0,1-21.5,21.5H221a21.53,21.53,0,0,1-21.5-21.5V279.47h27l-43.1-43.09-43.1,43.09h27V458.23A53.82,53.82,0,0,0,221,512H291a53.82,53.82,0,0,0,53.76-53.76V384.55H312.47Z"
      transform="translate(0 -0.01)"
    />
    <path
      d="M32.26,291V221a21.53,21.53,0,0,1,21.5-21.5H232.53v27l43.09-43.1-43.09-43.1v27H53.76A53.82,53.82,0,0,0,0,221V291a53.82,53.82,0,0,0,53.76,53.76H128V312.47H53.76A21.53,21.53,0,0,1,32.26,291Z"
      transform="translate(0 -0.01)"
    />
    <path
      d="M458.24,167.27H384.55v32.26h73.69a21.53,21.53,0,0,1,21.5,21.5V291a21.53,21.53,0,0,1-21.5,21.5H279.48v-27l-43.09,43.11,43.09,43.1v-27H458.24A53.82,53.82,0,0,0,512,291V221A53.82,53.82,0,0,0,458.24,167.27Z"
      transform="translate(0 -0.01)"
    />
  </svg>
);

LocalMed.displayName = 'LocalMed';

export default createIcon(LocalMed);
